import script from "./sjInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./sjInfo.vue?vue&type=script&setup=true&lang=js"

import "./sjInfo.vue?vue&type=style&index=0&id=0e24cad4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e24cad4"]])

export default __exports__